import { render, staticRenderFns } from "./UserConfigForm.vue?vue&type=template&id=b3d9b554"
import script from "./UserConfigForm.vue?vue&type=script&lang=js"
export * from "./UserConfigForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports